"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginDrawer = void 0;
require("../scss/loginDrawer.scss");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const customerAccountContext_1 = require("../contexts/customerAccountContext");
const Button_1 = require("./common/Button");
const constants_1 = require("../constants");
const LoginDrawer = ({ isOpen, onClose, onCreateAccountClick, onForgotPasswordClick }) => {
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const { user } = customerAccountContext.actions;
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const methods = (0, react_hook_form_1.useForm)();
    const [formGlobalErrorMessage, setFormGlobalErrorMessage] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setFormGlobalErrorMessage(undefined);
        methods.reset();
    }, [isOpen]);
    const signIn = (formData) => {
        setFormGlobalErrorMessage(undefined);
        return user
            .signIn(formData.email, formData.password)
            .then(() => {
            onClose();
        })
            .catch((error) => {
            setFormGlobalErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
        });
    };
    const handleCreateAccountClick = () => {
        onCreateAccountClick();
        onClose();
    };
    const handleForgotPasswordClick = () => {
        onForgotPasswordClick();
        onClose();
    };
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("div", { className: "boutik-customer-account-login" },
            isOpen && react_1.default.createElement("div", { className: "boutik-customer-account-login-overlay", onClick: onClose }),
            react_1.default.createElement("div", { className: `boutik-customer-account-login-drawer ${isOpen ? "boutik-customer-account-login-drawer-open" : ""}` },
                react_1.default.createElement("div", { className: "boutik-customer-account-login-header" },
                    react_1.default.createElement("h1", { className: "boutik-customer-account-login-header-title" }, t("loginDrawer.headerTitle")),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faXmark, className: "boutik-customer-account-login-header-close-btn", onClick: onClose })),
                react_1.default.createElement("form", { onSubmit: methods.handleSubmit(signIn), className: "boutik-customer-account-login-form-container" },
                    react_1.default.createElement("h1", { className: "boutik-customer-account-login-form-title" }, t("loginDrawer.title")),
                    react_1.default.createElement("p", { className: "boutik-customer-account-login-form-description" }, t("loginDrawer.description")),
                    react_1.default.createElement("p", { className: "boutik-customer-account-login-form-global-error-message" }, formGlobalErrorMessage),
                    react_1.default.createElement("div", { className: "boutik-customer-account-login-form-inputs" },
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: methods, classNamePrefix: "boutik-customer-account", placeholder: t("loginDrawer.email"), required: true, property: "email" }),
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: methods, classNamePrefix: "boutik-customer-account", placeholder: t("loginDrawer.password"), required: true, property: "password", isPassword: true })),
                    react_1.default.createElement("div", { className: "boutik-customer-account-login-form-buttons" },
                        react_1.default.createElement(Button_1.Button, { classNamePrefix: "boutik-customer-account-login", label: "loginDrawer.button.login", isSubmitButton: true, isLoading: methods.formState.isSubmitting }),
                        react_1.default.createElement("a", { className: "boutik-customer-account-login-forgot-password-link", onClick: handleForgotPasswordClick }, t("loginDrawer.button.forgotPassword")),
                        react_1.default.createElement("div", { className: "boutik-customer-account-login-form-buttons-division" },
                            react_1.default.createElement("hr", { className: "boutik-customer-account-login-form-buttons-division-line" }),
                            react_1.default.createElement("span", { className: "boutik-customer-account-login-form-buttons-division-line-text" }, t("loginDrawer.divisionLine")),
                            react_1.default.createElement("hr", { className: "boutik-customer-account-login-form-buttons-division-line" })),
                        react_1.default.createElement(Button_1.Button, { classNamePrefix: "boutik-customer-account-login-create-account", label: "loginDrawer.button.createAccount", onClick: handleCreateAccountClick })))))));
};
exports.LoginDrawer = LoginDrawer;
//# sourceMappingURL=LoginDrawer.js.map